<style scoped lang="scss">
.detail-table /deep/ .cell {
  white-space: pre-line;
}
.detail-table /deep/ td,
.detail-table /deep/ th {
  padding: 20px 0;
  text-align: center;
}
</style>
<template>
  <div class="detail-table">
    <div class="desc">擎科生物提供标准基因合成、大片段合成及基因组合成等多种服务，满足不同研究需求。</div>
    <el-table border :span-method="tableSpanMethod" :data="tableData">
      <el-table-column
        v-for="(item, index) in tableColumn"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      >
        <template slot-scope="scope">
          <div v-if="item.html" v-html="scope.row[item.prop]"></div>
          <div v-else>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tips.text" :style="tips.style">{{ tips.text }}</div>
  </div>
</template>

<script>
export default {
  name: "gene-detail-table",
  props: {
    tableColumn: {
      type: Array,
    },
    tableData: {
      type: Array,
    },
    tableSpanMethod: {
      type: Function,
    },
    tips: {
      type: Object,
      default: () => {
        return {
          text: "",
          style: null,
        };
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/products/gene-components/geneDetailTable.vue